var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-box"},[_c('div',{staticClass:"circle-border",style:(("height: " + _vm.height + "; width: " + _vm.width + ";"))},[_c('div',{staticClass:"circle-core"})])])}
var staticRenderFns = []

export { render, staticRenderFns }